import { combineEpics, Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { getType } from 'typesafe-actions';

import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import { applyCropSuccess } from '../AddCreativePage/actions';
import { CanvasAction } from '../common/actions';
import { CreativeCropApplyResponse } from '../common/requestsTypings';

import { closeModal, SaveModal, saveModal, showError } from './actions';
import { constructImageCropRequestData } from './helpers';
import { ImageCropRequestData } from './typings';

const applyCropEpic: Epic<CanvasAction, CanvasAction, State, EpicDeps> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(getType(saveModal)),
        switchMap(
            (action: SaveModal): Observable<CanvasAction> => {
                const {
                    cropData,
                    imageData,
                    sizeData,
                    isEditMode,
                    suggestedCenter
                } = store$.value.canvasEditor.canvas.creativeImageCropModal;
                const sharedData = store$.value.canvasEditor.sharedData;

                if (!cropData || !imageData || !sizeData) {
                    return of(showError());
                }

                const { resourceId } = imageData;
                const { cropSizes } = sizeData;

                return from(
                    constructImageCropRequestData(action.image, cropSizes, cropData, isEditMode, suggestedCenter)
                ).pipe(
                    switchMap((requestData: ImageCropRequestData) => {
                        return from(
                            deps.canvasApi.addCommonCreative.cropFile(resourceId, requestData.data, sharedData)
                        ).pipe(
                            switchMap((response: CreativeCropApplyResponse) => [
                                closeModal(),
                                applyCropSuccess(response, requestData.sizes)
                            ])
                        );
                    }),
                    catchError(error => of(showError(error && error.message)))
                );
            }
        )
    );
};

export const creativeImageCropModalEpics = combineEpics(applyCropEpic);
